import { render, staticRenderFns } from "./referrer.vue?vue&type=template&id=977f8d98&scoped=true&"
import script from "./referrer.vue?vue&type=script&lang=js&"
export * from "./referrer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f8d98",
  null
  
)

export default component.exports